module.exports = __webpack_public_path__ + "static/media/Raleway-Black.3fc090e7.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Raleway-Black.ttf
// module id = 3575
// module chunks = 71